import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";

interface PlaceholderPickerProps {
  onSelect: (placeholder: string) => void;
}

const PLACEHOLDERS = [
  { group: "User", items: [
    { label: "First Name", value: "{{first_name}}" },
    { label: "Last Name", value: "{{last_name}}" },
    { label: "Email", value: "{{email}}" },
  ]},
  { group: "Event", items: [
    { label: "Title", value: "{{event_title}}" },
    { label: "Venue", value: "{{event_venue}}" },
    { label: "Date", value: "{{event_date}}" },
    { label: "Time", value: "{{event_time}}" },
    { label: "ID", value: "{{event_id}}" },
    { label: "Meeting Point", value: "{{meeting_point}}" },
    { label: "Agenda", value: "{{agenda}}" },
    { label: "WhatsApp Group", value: "{{whatsapp_group}}" },
  ]},
  { group: "Host", items: [
    { label: "Host Name", value: "{{host_name}}" },
    { label: "Host Bio", value: "{{host_bio}}" },
  ]},
];

export function PlaceholderPicker({ onSelect }: PlaceholderPickerProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1">
          Insert
          <ChevronDown className="h-3 w-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {PLACEHOLDERS.map((group, idx) => (
          <div key={group.group}>
            {idx > 0 && <DropdownMenuSeparator />}
            <DropdownMenuLabel>{group.group}</DropdownMenuLabel>
            {group.items.map((item) => (
              <DropdownMenuItem
                key={item.value}
                onClick={() => onSelect(item.value)}
              >
                {item.label}
                <span className="ml-auto text-xs text-muted-foreground font-mono">
                  {item.value}
                </span>
              </DropdownMenuItem>
            ))}
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
